










































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Utils, DataBus, TireStoringContract, TireStoringInfo, ResponseCodeEnum, TireTypeEnum, ContractPeriodEnum, TireImage } from '@/models';
import { toastService, imageService } from '@/services';

import PaintImage from './PaintImage.vue';
import TireCamera from './TireCamera.vue';
import CarouselTireImage from './CarouselTireImage.vue';
// @ts-ignore
import { HeaderDropdown } from '@coreui/vue';

@Component({
  components: {
    PaintImage,
    TireCamera,
    CarouselTireImage,
    HeaderDropdown
  },
})
export default class TireRegisterInputPaint extends Vue {
  @Prop() public isEdit!: boolean;
  @Prop() public tireContract!: TireStoringContract;
  @Prop() public tireContractList!: TireStoringContract[];
  @Prop() public reNewParam!: string;

  private tire?: TireStoringInfo;
  private paintImage: HTMLImageElement = new Image();
  private showPaintImage: boolean = false;
  private showTabSummer: boolean = true;
  private showTabWinter: boolean = true;
  private currentTirePaint!: TireStoringInfo;
  public selectTabWinter: boolean = false;
  public onTakeTirePhoto: boolean = false;
  public currentTireSelected: any = {};
  
  get getTmpImage() {
    return require('@/assets/img/tire_scratch.png');
  }


  private async created() {
    if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
      this.tireContract.summerSeasonInfo.tires.forEach((tire) => {
        if (tire.imageScratchUrl.length === 0) {
          tire.imageScratchUrl = [this.getTmpImage];
        } else if(this.reNewParam === 'true') {
          // If isRenew conver old image to new id, new url
          let fileScratch: any = [];
          let imageScratchUrl: any =[];
          
          // renew id image
          tire.imageScratchUrl.forEach(async (element, index) => {
              let res: any = await Utils.convertUrlToBase64(element)
              if (res) {
                fileScratch.push(res);
                imageScratchUrl.push(URL.createObjectURL(res));
              }
          });
          tire.fileScratch = fileScratch;
          tire.imageScratchUrl = imageScratchUrl;
        }
      });
    }
    
    if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
      this.tireContract.winterSeasonInfo.tires.forEach((tire) => {
        if (tire.imageScratchUrl.length === 0) {
          tire.imageScratchUrl = [this.getTmpImage];
        } else if(this.reNewParam === 'true') {
          // If isRenew conver old image to new id, new url
          let fileScratch: any = [];
          let imageScratchUrl: any =[];

          // renew id image
          tire.imageScratchUrl.forEach(async (element, index) => {
              let res: any = await Utils.convertUrlToBase64(element)
              if (res) {
                fileScratch.push(res);
                imageScratchUrl.push(URL.createObjectURL(res));
              }
          });
          tire.fileScratch = fileScratch;
          tire.imageScratchUrl = imageScratchUrl;
        }
      });
    }
    this.paintImage.setAttribute('crossOrigin', 'anonymous');
    if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
      this.showTabSummer = this.tireContract.tireType === TireTypeEnum.SUMMER;
      this.showTabWinter = this.tireContract.tireType === TireTypeEnum.WINTER;
    } else {
      this.showTabSummer = true;
      this.showTabWinter = true;
    }
    if (this.tireContract.tireType === TireTypeEnum.WINTER) {
      this.selectTabWinter = true;
    }
  }

  private onSnapShot(tire: TireStoringInfo, index: number, isSummer: boolean) {
    this.onTakeTirePhoto = true;
    this.currentTireSelected = {
      tire,
      index,
      isSummer
    };
  }

  private deleteImage(imageIndex: number, tireIndex: number, isSummer: boolean) {
    if(isSummer) {
      if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires[tireIndex]) {
        this.tireContract.summerSeasonInfo.tires[tireIndex].imageScratchUrl.splice(imageIndex, 1);
        this.tireContract.summerSeasonInfo.tires[tireIndex].fileScratch.splice(imageIndex, 1);
        this.tireContract.summerSeasonInfo.tires[tireIndex].imageScratch.splice(imageIndex, 1);
      }
    } else {
      if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires[tireIndex]) {
        this.tireContract.winterSeasonInfo.tires[tireIndex].imageScratchUrl.splice(imageIndex, 1);
        this.tireContract.winterSeasonInfo.tires[tireIndex].fileScratch.splice(imageIndex, 1);
        this.tireContract.winterSeasonInfo.tires[tireIndex].imageScratch.splice(imageIndex, 1);
      }
    }
  }

  private openPaintImage(index: number, tireIndex: number, isSummer: boolean) {
    if (isSummer) {
      if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
        this.tire = this.tireContract.summerSeasonInfo.tires[tireIndex];
      }
    } else if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
      this.tire = this.tireContract.winterSeasonInfo.tires[tireIndex];
    }
    if (this.tire) {
      if (!this.tire.imageScratchUrl[index]) {
        return;
      }
      this.currentTireSelected.tire = this.tire;
      this.currentTireSelected.index = tireIndex;
      this.currentTireSelected.imageIndex = index;
      this.currentTirePaint = this.tire;
      this.paintImage.setAttribute('crossOrigin', 'anonymous');
      this.paintImage.src = this.tire.imageScratchUrl[index] || "";
      this.currentTireSelected.isSummer = isSummer;
      this.paintImage.onload = () => {
        this.showPaintImage = true;
        this.selectTabWinter = this.tire ? this.tire.type === TireTypeEnum.WINTER : false;
      };
    }
  }
  private selectedImage(index: number, tireIndex: number, isSummer: boolean) {
    if (isSummer) {
      if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
        this.tireContract.summerSeasonInfo.tires[tireIndex].imageScratchIndex = index;
      }
    } else if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
      this.tireContract.winterSeasonInfo.tires[tireIndex].imageScratchIndex = index;
    }
  }

  private openDefaultPainImage(tire: TireStoringInfo, index: number, isSummer: boolean) {
    this.currentTireSelected.tire = tire;
    this.currentTireSelected.index = index;
    this.currentTireSelected.imageIndex = 0;
    this.currentTirePaint = tire;
    this.tire = tire;
    this.paintImage.setAttribute('crossOrigin', 'anonymous');
    this.paintImage.src = tire.imageScratchUrl[0];
    this.currentTireSelected.isSummer = isSummer;
    this.paintImage.onload = () => {
      this.showPaintImage = true;
      this.selectTabWinter = this.tire ? this.tire.type === TireTypeEnum.WINTER : false;
    };
  }

  private handlePaintEvent(data: DataBus) {
    if (data.event === 'back') {
      this.showPaintImage = false;
    } else if (data.event === 'save') {
      if (this.currentTirePaint.type === undefined || this.currentTirePaint.no === undefined) {
        this.showPaintImage = false;
        return;
      }
      const arr = data.data.split(',');
      const mimeType = arr[0].match(/:(.*?);/)[1];
      
      this.urlToFile(data.data, this.currentTirePaint.type + this.currentTirePaint.no + '.png', mimeType)
        .then((res) => {
          this.currentTirePaint.fileScratch[this.currentTireSelected.imageIndex] = res;
          this.currentTirePaint.imageScratchUrl[this.currentTireSelected.imageIndex] = data.data;
        });
      if (this.currentTireSelected.isSummer) {
        if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index]) {
          this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl[this.currentTireSelected.imageIndex] = data.data;
        }
      } else {
        if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index]) {
          this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl[this.currentTireSelected.imageIndex] = data.data;
        }
      }
      this.showPaintImage = false;
    }
  }

  private urlToFile(url: string, filename: string, mimeType: string) {
    return (fetch(url)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], filename, { type: mimeType })));
  }

  private save(): Promise<any> {
    return new Promise((resolve, reject) => {
      const summerTires: TireStoringInfo[] = this.tireContract.summerSeasonInfo ? this.tireContract.summerSeasonInfo.tires : [];
      const summerExistImages: any[] = summerTires
        .map((t1, index) => {
          return {
            fileIndex: index,
            fileScratch: t1.fileScratch,
          };
        })
        .filter((t2) => t2.fileScratch !== undefined);
      const summerImageFiles: File[] = summerExistImages.flatMap((img) => img.fileScratch);

      const winterTires: TireStoringInfo[] = this.tireContract.winterSeasonInfo ? this.tireContract.winterSeasonInfo.tires : [];
      const winterExistImages: any[] = winterTires
        .map((t2, index) => {
          return {
            fileIndex: index,
            fileScratch: t2.fileScratch,
          };
        })
        .filter((t2) => t2.fileScratch !== undefined);
      const winterImageFiles: File[] = winterExistImages.flatMap((img) => img.fileScratch);
      // Upload images
      imageService.saveTireScratchImage(summerImageFiles, winterImageFiles)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            if (res.data.data.summerTireImages) {
              const data = res.data.data.summerTireImages;
              summerExistImages.forEach((item, indexTire) => {
                if(item.fileScratch.length > 0){
                  if (this.reNewParam === 'true') {
                    this.tireContract.summerSeasonInfo!.tires[indexTire].imageScratch  = [];
                  }
                  var arr = data.splice(0, item.fileScratch.length);
                  if (this.tireContract.summerSeasonInfo
                    && this.tireContract.summerSeasonInfo.tires
                    && this.tireContract.summerSeasonInfo.tires[indexTire]) 
                  {
                    arr.forEach((image, index) => {
                      let tireImage: TireImage = new TireImage();
                      tireImage.id = image.id;
                      tireImage.imageUrl = image.filePath;
                      tireImage.location = this.tireContract.summerSeasonInfo!.tires[indexTire].imageScratch.length;
                      this.tireContract.summerSeasonInfo!.tires[indexTire].imageScratch.push(tireImage!);
                    })
                  }
                }
              })
            }
            if (res.data.data.winterTireImages) {
              const data = res.data.data.winterTireImages;
              winterExistImages.forEach((item, indexTire) => {
                if(item.fileScratch.length > 0){
                  if (this.reNewParam === 'true') {
                    this.tireContract.winterSeasonInfo!.tires[indexTire].imageScratch  = [];
                  }
                  var arr = data.splice(0, item.fileScratch.length);
                  if (this.tireContract.winterSeasonInfo
                    && this.tireContract.winterSeasonInfo.tires
                    && this.tireContract.winterSeasonInfo.tires[indexTire]) 
                  {
                    arr.forEach((image, index) => {
                      let tireImage: TireImage = new TireImage();
                      tireImage.id = image.id;
                      tireImage.imageUrl = image.filePath;
                      tireImage.location = this.tireContract.winterSeasonInfo!.tires[indexTire].imageScratch.length;
                      this.tireContract.winterSeasonInfo!.tires[indexTire].imageScratch.push(tireImage!);
                    })
                  }
                }
              });
            }
            resolve();
            return;
          } 
          reject();     
          return;
        });
    })
  }

  private async clearScratchUrl() {
    const templateUrl = require('@/assets/img/tire_scratch.png');
    if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
      this.tireContract.summerSeasonInfo.tires.forEach((tire) => {
        tire.imageScratchUrl = [];
        if (!tire.fileScratch && tire.imageScratchUrl === templateUrl) {
        }
      });
    }
    if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
      this.tireContract.winterSeasonInfo.tires.forEach((tire) => {
        tire.imageScratchUrl = [];
        if (!tire.fileScratch && tire.imageScratchUrl === templateUrl) {
        }
      });
    }
  }

  private async saveAndGoBack() {
    await this.save().then(async () => {
      await this.clearScratchUrl();
      this.$emit('loadComponent', new DataBus({
        event: 'confirm_info',
      }));
    });
  }

  private cancelRegister() {
    if (!this.isEdit) {
      this.$emit('loadComponent', new DataBus({
        event: 'cancel_register',
      }));
    }
  }

  private back() {
    this.$emit('loadComponent', new DataBus({
      event: 'info',
    }));
  }
  

  private goToImageUpload() {
    this.save().then(() => {
      this.clearScratchUrl();
      this.$emit('loadComponent', new DataBus({
        event: 'image',
      }));
    });
  }

  private cameraClosed() {
    this.onTakeTirePhoto = false;
    let tracks = (this.$refs.camera as any).srcObject.getTracks();
    tracks.forEach((track: any) => {
      track.stop();
    });
  }

  /**nen anh */
  private async resizeImageURL(datas: any, wantedWidth: any, wantedHeight: any){
    return await new Promise(async function(resolve,reject){
      // We create an image to receive the Data URI
      var img = document.createElement('img');

      img.onload = function() {        
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d')!;

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(img, 0, 0, wantedWidth, wantedHeight);

        var dataURI = canvas.toDataURL();

        // This is the return of the Promise
        resolve(dataURI);
      };
      // We put the Data URI in the image's src attribute
      img.src = datas;
    })
  }

  private onSnapTireImage(imageBase64: any) {
    this.onTakeTirePhoto = false;
    this.cameraClosed();
    const arr = imageBase64.split(',');
    const mimeType = arr[0].match(/:(.*?);/)[1];

    var img = this.resizeImageURL(imageBase64, 384, 288);
    img.then(res => {
        imageBase64 = res;
        if (this.currentTireSelected) {
          if (this.currentTireSelected.isSummer) {
            if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index]) {
              // Clear default image
              if(this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl[0] === this.getTmpImage) {
                this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl = [];
              }
              this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl.push(imageBase64);
              this.urlToFile(imageBase64, TireTypeEnum.SUMMER + (this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl.length) + '.png', mimeType)
                .then((res) => {
                  if (this.tireContract.summerSeasonInfo) {
                    this.tireContract.summerSeasonInfo.tires[this.currentTireSelected.index].fileScratch.push(res);
                  }
                });
            }
          } else {
            if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index]) {
              // Clear default image
              if(this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl[0] === this.getTmpImage) {
                this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl = [];
              }
              this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl.push(imageBase64);
              this.urlToFile(imageBase64, TireTypeEnum.WINTER + (this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index].imageScratchUrl.length) + '.png', mimeType)
                .then((res) => {
                  if (this.tireContract.winterSeasonInfo) {
                    this.tireContract.winterSeasonInfo.tires[this.currentTireSelected.index].fileScratch.push(res);
                  }
                });
            }
          }
        }
    });  
  }

  private addTireImage(isSummer: boolean, index: number) {
    this.currentTireSelected = {
      isSummer,
      index
    };
    this.onTakeTirePhoto = true;
  }

  private chooseImage(event: any, tire: any, indexTire: number) {
    const file = event.target.files[0];
    // clear default image
    if(tire.imageScratchUrl[0] === this.getTmpImage) {
       tire.imageScratchUrl = [];
    }
    // tire.fileScratch.push(file);
    Utils.getImage(file)
      .then((res) => {
        
        tire.fileScratch.push(res);
        tire.imageScratchUrl.push(URL.createObjectURL(res));
    });
  }

  private selectFile(name: string) {
    document.getElementById(name)!.click();
  }
}
